import { Text } from '@make-software/tg-mini-app-ui';
import styled from 'styled-components';

export const StatusMessage = styled(Text)<{ success?: boolean }>(({ theme, success }) =>
  theme.withMedia({
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '140%',
    color: success ? '#31DE91' : '#FB6F6A',
    marginBottom: '8px',
    fontFamily: 'Inter'
  })
);
